<template>
    <div class="registration">
        <div class="text-center mb-5">
            <div class="fs-18 lh-lg font-weight-light t-dark-grey mb-2">CAT-UXO Advertiser</div>
            <h1>Create your account and subscribe</h1>
        </div>
        <section class="column is-8-desktop px-0 px-sm-2 mx-auto">
            <form method="POST" class="form form-register">
                <div v-if="errors" class="errors mb-4">
                    <template v-for="(field) in errors">
                        <div v-for="(error) in field" class="error">{{error}}</div>
                    </template>
                </div>
                    <div class="card p-4 m-4 bg-white border-radius account-details d-flex flex-column justify-content-center">
                        <div class="columns">
                            <div class="column is-half">
                                <div class="field mb-4" :class="{ 'has-error': $v.form.fullName.$error }">
                                    <label class="label mb-1" for="fullName">Full Name*</label>
                                    <div class="control">
                                        <input id="fullName" name="full_name" class="input" type="text"
                                               v-model.trim="$v.form.fullName.$model"/>
                                    </div>
                                    <div class="error" v-if="$v.$dirty && $v.form.fullName.$error">
                                        {{getErrorMessage($v.form.fullName)}}
                                    </div>
                                </div>
                            </div>
                            <div class="column is-half">
                                <div class="field mb-4" :class="{ 'has-error': $v.form.email.$error }">
                                    <label class="label mb-1" for="email">Email Address*</label>
                                    <div class="control">
                                        <input id="email" name="email" class="input" type="email"
                                               v-model.trim="$v.form.email.$model"/>
                                    </div>
                                    <div class="error" v-if="$v.$dirty && $v.form.email.$error">
                                        {{getErrorMessage($v.form.email)}}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="columns">
                            <div class="column is-half">
                                <div class="field mb-4" :class="{ 'has-error': $v.form.password.$error }">
                                    <label class="label mb-1" for="password">Password*</label>
                                    <div class="control">
                                        <input id="password" name="password" class="input" type="password"
                                               v-model.trim="$v.form.password.$model">
                                    </div>
                                    <div class="error" v-if="$v.$dirty && $v.form.password.$error">
                                        {{getErrorMessage($v.form.password)}}
                                    </div>
                                </div>
                            </div>
                            <div class="column is-half">
                                <div class="field mb-4" :class="{ 'has-error': $v.form.passwordConfirmation.$error }">
                                    <label class="label mb-1" for="passwordConfirmation">Confirm Password*</label>
                                    <div class="control">
                                        <input id="passwordConfirmation" name="password_confirmation" class="input"
                                               type="password" v-model.trim="$v.form.passwordConfirmation.$model"/>
                                    </div>
                                    <div class="error" v-if="$v.$dirty && $v.form.passwordConfirmation.$error">
                                        {{getErrorMessage($v.form.passwordConfirmation)}}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="columns">
                            <div class="column is-full">
                                <div class="field mb-4">
                                    <label for="cardnumber" class="label required mb-1">
                                        Card Details
                                    </label>
                                    <div ref="card" class="stripe-card"></div>
                                    <span
                                        id="card-errors"
                                        class="error mt-1"></span>
                                </div>
                            </div>
                        </div>
                        <div class="columns">
                            <div class="column is-full">
                                <div class="field" :class="{ 'has-error': $v.form.toc.$error }">
                                    <label class="position-relative d-flex align-items-center">
                                        <input name="toc" class="input-checkbox" type="checkbox"
                                               v-model.trim="$v.form.toc.$model"/>
                                        <span class="check-toggle"></span>
                                        <span class="toc pl-2 ml-1 font-weight-light">Accept that you have read our
                                        <a class="btn-link" target="_blank" href="/privacy-policy">Privacy Policy</a> and <a class="btn-link" href="/terms-conditions" target="_blank">Terms & Conditions</a></span>
                                    </label>
                                    <div class="error" v-if="$v.$dirty && $v.form.toc.$error">
                                        {{getErrorMessage($v.form.toc)}}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="field mx-auto d-flex flex-column justify-content-center">
                        <button v-if="!loading"
                                @click.prevent="subscribe"
                                class="mx-auto py-3 btn btn-form"
                        >

                            Create your account and pay {{ subscriptionDiscount }}
                        </button>
                        <pulse-loader v-if="loading"
                                      :loading="true"
                                      :color="'#E57722'"
                                      class="d-flex justify-content-center align-items-center align-self-stretch flex-fill col-5 my-2 mh-100"
                                      :size="'20px'">
                        </pulse-loader>
                        <p class="note mx-auto mt-2 fs-16">Your subscription will start immediately</p>
                    </div>
            </form>
        </section>
    </div>
</template>

<script>

    import {required, email, sameAs} from 'vuelidate/lib/validators';
    import {Card, createToken} from 'vue-stripe-elements-plus'
    import {mapGetters, mapState} from "vuex";
    import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
    import {axiosApi, axiosWeb} from "@/js/axios";

    import {loadStripe} from '@stripe/stripe-js';

    export default {
        name: 'CatUxoFormAdSignUp',
        components: {
            Card,
            PulseLoader,
        },
        props: {
            plan: {
                type: Object,
                required: true,
            }
        },
        data: function () {
            return {
                form: {
                    csrfToken: null,
                    fullName: null,
                    email: null,
                    password: null,
                    passwordConfirmation: null,
                    billingCard: null,
                    toc: false,
                },
                complete: false,
                loading: false,
                user: '',
                errors: []
            }
        },
        computed: {
            ...mapState('shared', [
                'stripeKey',
                'stripeOptions'
            ]),
            ...mapGetters('form', [
                'getErrorMessage'
            ]),
            rules() {
                return {
                    fullName: {
                        required,
                    },
                    email: {
                        required,
                        email,
                    },
                    password: {
                        required,
                    },
                    passwordConfirmation: {
                        required,
                        sameAsPassword: sameAs('password')
                    },
                    toc: {
                        checked: value => value === true
                    },
                }
            },
            interval() {
                return this.plan.interval;
            },
            price() {
                return this.plan.price;
            },
            subscriptionDiscount() {
                let price = this.plan.price
                let discount = (price / 2).toFixed(2);

                return `£${discount}`;
            },

            subscriptionPrice() {
                return this.form.subscription_type === 'monthly' ? `£${this.monthlyPrice}` : `£${this.yearlyPrice}`;
            },
        },
        watch: {
            step(val) {
                this.scrollTop();
            },
        },

        mounted() {
            this.loadStripe();
        },

        methods: {
            async loadStripe() {
                this.stripe = await loadStripe(this.stripeKey);

                this.elements = this.stripe.elements();
                this.card = this.elements.create('card', {style: this.style});
                this.card.mount(this.$refs.card);
            },

            scrollTop() {
                window.scrollTo(0,0);
            },

            // STRIPE PAYMENTS
            subscribe() {
                const $this = this;

                $this.$v.form.$touch();
                if ($this.$v.form.$invalid) {
                    return;
                }

                this.loading = true;

                let errorElement = document.getElementById('card-errors');
                errorElement.textContent = '';

                this.stripe.createToken(this.card).then(function(data) {

                    if (data.error) {
                        let errorElement = document.getElementById('card-errors');
                        errorElement.textContent = data.error.message;

                        $this.loading = false;

                        return;
                    }

                    $this.form.source = data.token;
                    $this.form.setup = true;

                    $this.createCustomerSubscription();
                });
            },

            createCustomerSubscription() {
                const $this = this;
                return axiosWeb.post(`/api/v1/a-subscription?plan=${$this.interval}`, $this.form).then(({data}) => {
                    if (data.status === 'incomplete') {
                        this.authorizePayment(data.paymentIntent.client_secret, data.action);
                    } else {
                        if (data.action === 'create') {
                            this.createAccount(data.paymentIntent.client_secret);
                        } else {
                            this.updateAccount(data.paymentIntent.client_secret);
                        }
                    }
                }).catch((error) => {
                    $this.loading = false;
                    if (error.response.status === 422) {
                        $this.errors = error.response.data.errors;
                    } else if (error.response.status === 402) { // Payment Failed
                        // Inform the user if there was an error.
                        let errorElement = document.getElementById('card-errors');
                        errorElement.textContent = error.response.data.error.message;
                    } else {
                        // Inform the user if there was an error.
                        let errorElement = document.getElementById('card-errors');
                        errorElement.textContent = 'There was an error registering your account. Please try again or contact us at hello@cat-uxo.com';
                    }
                })
            },
            authorizePayment(clientSecret, action) {
                const $this = this;
                this.stripe.confirmCardPayment(clientSecret, {
                    payment_method: {
                        card: $this.card,
                    },
                })
                    .then(function(result) {
                        if (result.hasOwnProperty('error')) {
                            return $this.failSubscriptionAttempt(clientSecret);
                        }

                        if (result.hasOwnProperty('paymentIntent')) {
                            return action === 'create'
                                ? $this.createAccount(clientSecret)
                                : $this.updateAccount(clientSecret);
                        }
                    })
                    .catch((error) => {
                        $this.failSubscriptionAttempt(clientSecret);
                    });
            },
            createAccount(clientSecret) {
                const $this = this;
                this.form['payment_intent_id'] = clientSecret;
                return axiosWeb.post(`/api/v1/register/a-subscriber`, $this.form)
                    .then(({data}) => {
                        setTimeout(function () {
                            window.location.href = '/settings/advertisement';
                        }, 2000);
                    });
            },
            updateAccount(clientSecret) {
                const $this = this;
                this.form['payment_intent_id'] = clientSecret;
                return axiosWeb.put(`/api/v1/update/a-subscriber`, $this.form)
                    .then(({data}) => {
                        setTimeout(function () {
                            window.location.href = '/settings/advertisement';
                        }, 2000);
                    });
            },
            failSubscriptionAttempt(clientSecret) {
                axiosWeb.put(`/api/v1/pending-subscriber/${clientSecret}`);

                this.loading = false;

                let errorElement = document.getElementById('card-errors');
                errorElement.textContent = 'Payment authorization has failed. Please try again or choose different payment method.';
            },

            // submit() {
            //     let $this = this;
            //     $this.$v.form.$touch();
            //     if ($this.$v.form.$invalid) return;
            //
            //     $this.errors = [];
            //     createToken().then(function (data) {
            //
            //
            //         if (data.error) {
            //             $this.loading = false;
            //
            //             // Inform the user if there was an error.
            //             let errorElement = document.getElementById('card-errors');
            //             errorElement.textContent = data.error.message;
            //
            //             return;
            //         }
            //
            //         // Display the loading on the button
            //         $this.loading = true;
            //
            //         // Add token data used to make request to the API
            //         $this.form.source = data.token;
            //
            //         $this.form.setup = true;
            //
            //         // Send the token to your server.
            //         return axiosWeb.post(`/api/v1/a-subscription?plan=${$this.interval}`, $this.form).then(response => {
            //             Spark.post(`/login`, new SparkForm({
            //                 email: $this.form.email,
            //                 password: $this.form.password
            //             })).then(() => window.location.href = '/settings/advertisement' )
            //         }).catch((error) => {
            //             $this.loading = false;
            //
            //             if (error.response.status === 422) {
            //                 $this.step = 1;
            //                 $this.errors = error.response.data.errors;
            //             } else if (error.response.status === 402) { // Payment Failed
            //                 // Inform the user if there was an error.
            //                 let errorElement = document.getElementById('card-errors');
            //                 errorElement.textContent = error.response.data;
            //             } else {
            //                 // Inform the user if there was an error.
            //                 let errorElement = document.getElementById('card-errors');
            //                 errorElement.textContent = 'There was an error registering your account. Please try again or contact us at hello@cat-uxo.com';
            //             }
            //         })
            //     });
            //
            // },
        },

        validations() {
            return {
                form: this.rules
            }
        },
    }
</script>

<style lang="scss" scoped>
    .account-details{
        box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.03);
    }
    .note{
        color: $c-navy-blue;
    }
    .btn-form{
        max-width: none
    }
    @media screen and (max-width: 620px){
        .card {
            margin: 0 0 20px 0 !important;
            padding: 10px !important;
        }
        .input-checkbox ~ .check-toggle{
            height: 2rem;
            width: 4rem;
        }
    }
</style>



// WEBPACK FOOTER //
// resources/js/components/forms/AdSignUp.vue